// extracted by mini-css-extract-plugin
export default {"btnpwd":"_869e1e4e81"};